import { CONDITION_FIELDS } from "../rule-sets/condition-field-config"

const SCENARIO_FIELD_VALUES = new Set([
    "facilityName",
    "town",
    "postcode",
    "assetType",
    "regimeField",
    "assetField",
    "classification",
    "trade",
])

export const SCENARIO_CONDITION_FIELDS = CONDITION_FIELDS.filter(isScenarioField)

function isScenarioField(f) {
    return SCENARIO_FIELD_VALUES.has(f.value)
}
